/* eslint-disable indent */
import { FormInstance } from 'antd/lib/form';
import { Col, Form, Input, Row, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { ClientFeatureConfig } from '../../../types/Feature';
import FeatureStatusInput from '../../Shared/Inputs/FeatureStatusInput';

interface ClosingToolFormSectionProps {
    formInstance: FormInstance;
    closingToolConfig?: ClientFeatureConfig<any>;
    isDetailMode?: boolean;
    enableControls?: boolean;
    resetFormFlag?: boolean;
}

const ClosingToolFormSection: React.FC<ClosingToolFormSectionProps> = (props: ClosingToolFormSectionProps) => {
    const { formInstance, closingToolConfig, isDetailMode, enableControls, resetFormFlag } = props;

    const [isFeatureDisabled, setIsFeatureDisabled] = useState<boolean>(false);

    useEffect(() => {
        setIsFeatureDisabled(true);
    }, [resetFormFlag]);

    useEffect(() => {
        if (closingToolConfig) {
            formInstance.setFields([
                { name: 'createJobEnabled', value: closingToolConfig.config.createJobEnabled },
                { name: 'validationEnabled', value: closingToolConfig.config.validationEnabled },
                { name: 'etaEnabled', value: closingToolConfig.config.etaEnabled },
                { name: 'pricingEnabled', value: closingToolConfig.config.pricingEnabled },
                { name: 'clientCode', value: closingToolConfig.config.clientCode },
            ]);
            setIsFeatureDisabled(false);
        }
    }, [closingToolConfig]);

    return (
        <>
            <div className="card border-0" id="fleets-section">
                <div className="card-header border-bottom d-flex justify-content-between align-items-center bg-white">
                    <p className="m-0 p-0 h5" style={{ fontSize: '18px' }}>
                        Closing Tool
                    </p>
                </div>
                <div className="card-body">
                    <Row gutter={24}>
                        <Col span={8}>
                            <Form.Item name="clientCode" id="clientCode" label="client Code">
                                {isDetailMode ? (
                                    <span className="ant-form-text text-secondary">
                                        {closingToolConfig?.config.clientCode || '-'}
                                    </span>
                                ) : (
                                    <Input className="col-8" name="clientCode" title="client code" />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <div className="d-inline-flex align-items-center">
                            <span className="mr-2 d-none d-sm-block">Validation for &apos;Create Job&apos;:</span>
                            <FeatureStatusInput
                                name="createJobEnabled"
                                id="createJobEnabled"
                                isDetailMode={isDetailMode}
                                enabled={closingToolConfig?.config.createJobEnabled}
                                isFeatureDisabled={isFeatureDisabled}
                            />
                        </div>
                    </Row>
                    <Row gutter={24}>
                        <div className="d-inline-flex align-items-center">
                            <span className="mr-2 d-none d-sm-block">Validation for &apos;Validate Job&apos;:</span>
                            <FeatureStatusInput
                                name="validationEnabled"
                                id="validationEnabled"
                                isDetailMode={isDetailMode}
                                enabled={closingToolConfig?.config.validationEnabled}
                                isFeatureDisabled={isFeatureDisabled}
                            />
                        </div>
                    </Row>
                    <Row gutter={24}>
                        <div className="d-inline-flex align-items-center">
                            <span className="mr-2 d-none d-sm-block">Validation for &apos;ETA&apos;:</span>
                            <FeatureStatusInput
                                name="etaEnabled"
                                id="etaEnabled"
                                isDetailMode={isDetailMode}
                                enabled={closingToolConfig?.config.etaEnabled}
                                isFeatureDisabled={isFeatureDisabled}
                            />
                        </div>
                    </Row>
                    <Row gutter={24}>
                        <div className="d-inline-flex align-items-center">
                            <span className="mr-2 d-none d-sm-block">Validation for &apos;Pricing&apos;:</span>
                            <FeatureStatusInput
                                name="pricingEnabled"
                                id="pricingEnabled"
                                isDetailMode={isDetailMode}
                                enabled={closingToolConfig?.config.pricingEnabled}
                                isFeatureDisabled={isFeatureDisabled}
                            />
                        </div>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default ClosingToolFormSection;
